import { DefaultProps } from 'typings'
import { styles } from './styles'
import { cx } from '@vtex/admin-ui'

type Props = DefaultProps & {
  columns: 'fill' | 'split'
}

export function CardLine(props: Props) {
  const { children, columns } = props

  return (
    <div data-columns={columns} className={cx(styles.card.line, 'card-line')}>
      {children}
    </div>
  )
}
